import {
  ANSWER_PROMPT_MAX,
  ANSWER_REFRESH_HOURS,
  ANSWER_WIDGET_TYPE,
} from "@kourai/api/home-answer";
import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/**
 * A chat answer kept on the board (ADMIN-266), made by "Pin to home", never from the add tray.
 * Declarative: its config is a source (the question) and a schedule; its content is markdown and a
 * visual, drawn by the same parts chat answers use. No code runs.
 */
export default defineWidget({
  type: ANSWER_WIDGET_TYPE,
  version: 1,
  title: "Pinned answer",
  description: "An answer from a chat, kept here",
  sizes: ["m", "l", "w", "xl"],
  defaultSize: "l",
  surfaces: ["newtab", "sidepanel"],
  data: "member",
  permissions: [],
  addable: false,
  config: z.object({
    title: z.string().max(80).default("Pinned answer"),
    /** Where the content comes from: the question, for now (a fetch, a page, MCP later). */
    source: z.literal("prompt").default("prompt"),
    prompt: z.string().max(ANSWER_PROMPT_MAX).default(""),
    /** The model it was asked with, so a refresh answers in the same voice. */
    model: z.string().max(80).default(""),
    refreshHours: z
      .number()
      .int()
      .refine((n) => (ANSWER_REFRESH_HOURS as readonly number[]).includes(n))
      .default(0),
  }),
  load: () => import("./answer-widget"),
});
